@if(state){<p class="text-center text-secondary fs-5">{{'poll_creation.preview' | translate}}</p>}
@if(kudos.kudosType || kudos.recipients.selectedTeammates.length > 0 || kudos.recipients.allTeamSelected){
    <div class="preview-item">
        <div class="border rounded bg-white card kudos-card position-relative">
                <!-- Kudos card ligth version -->
                <div class="">
                    @if(kudos.kudosType){
                        <div class="kudos-badge">
                            <span>{{'kudos.type.'+ kudos.kudosType | translate}} - </span>{{'Kudos' | translate }}
                        </div>
                    }
                    <div class="card-top">
                            <div class="pe-2">
                                @switch (kudos.kudosType){
                                    @case ('thanks'){
                                        <i class="fa-light fa-hands-holding-heart hands-holding-heart-icon ms-2 position-relative text-secondary"></i>
                                    }
                                    @case ('congratulate'){
                                        <i class="fa-light fa-hands-clapping fa-2x ms-2 position-relative text-secondary"></i>
                                    }
                                    @case ('celebrate'){
                                        <i class="fa-sharp fa-light fa-party-horn fa-2x ms-2 position-relative text-secondary"></i>
                                    }
                                    @default{
                                        <i class="fa-light fa-hands-holding-heart hands-holding-heart-icon ms-2 position-relative text-secondary"></i>
                                    }
                                }
                            </div>
                        <div class="w-100">
                            @if(kudos.recipients.selectedTeammates.length > 0 || kudos.recipients.allTeamSelected){
                                <tm-kudos-recipients-display [recipients]="kudos.recipients" [author]="kudos.author"></tm-kudos-recipients-display>
                            }@else{
                                <div class="kudos-placeholder"></div>
                            }
                            <div class="card-comment p-3">
                                <!-- <span class="card-comment-body" [innerHtml]="$safeNavigationMigration(mood.comment?.body) | removeGifUrls: $safeNavigationMigration(mood.comment?.linkPreviews) | linky"></span> -->
                                <span class="card-comment-body fst-italic" [innerHtml]="$safeNavigationMigration(kudos.message.body) | removeGifUrls: $safeNavigationMigration(gifPreviews) | linky"></span>
                                @if(gifPreviews?.length > 0){
                                    @for (gifPreview of gifPreviews; track gifPreview.url){
                                        <tm-gif-preview [gifPreview]="gifPreview"></tm-gif-preview>
                                    }
                                }
                            </div>

                        </div>
                    </div>  
                </div>
                 <!--  -->                
        </div>
        <div class="pb-4">
            @if(state === 'choose' || state === 'customize' || state === 'publish'){
                <div class="preview-item">
                    <anonymity-preview [userInfos]="userInfos"
                                       [itemType]="kudos.itemType"
                                       [isAnonymous]="false"></anonymity-preview>
                </div>
                <div class="preview-item">
                    <div class="d-flex gx-2 mt-2">
                        <div class="text-secondary preview-icon pe-1">
                            @if(kudos?.privacy === 'private'){
                                <i class="fa-light fa-eye-slash"></i>
                            } @else {
                                <i class="fa-light fa-eye"></i>
                            }
                        </div>
                        <div class="">
                            <div class="px-3">
                                @if(kudos?.privacy === 'private'){
                                {{'kudos-creation-dialog.privacy-preview.private' | translate}}
                                } @else {
                                {{'kudos-creation-dialog.privacy-preview.public' | translate}}
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
            @if(state === 'publish'){
                <div class="preview-item">
                    <publication-preview [itemType]="kudos.itemType"
                                         [publishNow]="true"></publication-preview>
                </div>
                <div class="preview-item">
                    <notification-preview [itemType]="kudos.itemType"></notification-preview>
                </div>
            }
        </div>
    </div>
}@else {
    <div class="preview-item">
        <div class="question-placeholder rounded">
            <div class="card-top p-0"></div>
            <div class="px-4 py-3 pb-2 ">
                <p class="text-center text-secondary fst-italic p-5">
                    {{'poll_creation.preview_select_template' | translate}}
                </p>                        
            </div>
        </div>
    </div>
}